function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (continueBtnText, doneText, game, hasNarration, hasPrompt, i18n, klass, metadata, prompt, submitUp, title) {
      if (game && game.timer && game.timer.limit > 0 && !game.timer.isDisabled) {
pug_html = pug_html + "\u003Cdiv class=\"full-screen\"\u003E\u003Cdiv class=\"game-stepper text-lg text-bold\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"game-progress\"\u003E\u003Cdiv class=\"game-progress-bar\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_mixins["image"] = pug_interp = function(imageUrl, klass, alt){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cimg" + (pug_attr("class", pug_classes([klass], [true]), false, true)+pug_attr("src", imageUrl, true, true)+pug_attr("alt", alt, true, true)) + "\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"content-fill\"\u003E\u003Cdiv class=\"block-v-md content-fill content-sm-ver content-md-ver\"\u003E\u003Cdiv class=\"row content-fill content-area text-center\"\u003E\u003Cdiv class=\"col-sm-12 col-lg-6 content-lg-ver\"\u003E\u003Ch1 class=\"title tight block-v-md\"\u003E" + (null == (pug_interp = title) ? "" : pug_interp) + "\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"col-sm-12 col-lg-6\"\u003E";
// iterate metadata.questions
;(function(){
  var $$obj = metadata.questions;
  if ('number' == typeof $$obj.length) {
      for (var j = 0, $$l = $$obj.length; j < $$l; j++) {
        var pair = $$obj[j];
var question = pair.question;
var answers = pair.answers;
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E";
// iterate _.shuffle(pair.answers)
;(function(){
  var $$obj = _.shuffle(pair.answers);
  if ('number' == typeof $$obj.length) {
      for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
        var answer = $$obj[i];
klass  = answer.correct ? "correct" : "incorrect"
klass += i === 0 ? " left" : " right"
pug_html = pug_html + "\u003Cdiv class=\"col-sm-6 block-v-sm slide-up hide-overflow block-box-sizing\"\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["image-container","block-dk","block-sm","content-fill",klass], [false,false,false,false,true]), false, true)+pug_attr("data-correct", answer.correct, true, true)+pug_attr("data-content", answer.content, true, true)+pug_attr("data-answer-id", answer.id, true, true)+pug_attr("data-question-id", question.id, true, true)+pug_attr("data-group", j, true, true)+pug_attr("data-image", i, true, true)) + "\u003E";
pug_mixins["image"](answer.content, 'img content-ver block');
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;
      var answer = $$obj[i];
klass  = answer.correct ? "correct" : "incorrect"
klass += i === 0 ? " left" : " right"
pug_html = pug_html + "\u003Cdiv class=\"col-sm-6 block-v-sm slide-up hide-overflow block-box-sizing\"\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["image-container","block-dk","block-sm","content-fill",klass], [false,false,false,false,true]), false, true)+pug_attr("data-correct", answer.correct, true, true)+pug_attr("data-content", answer.content, true, true)+pug_attr("data-answer-id", answer.id, true, true)+pug_attr("data-question-id", question.id, true, true)+pug_attr("data-group", j, true, true)+pug_attr("data-image", i, true, true)) + "\u003E";
pug_mixins["image"](answer.content, 'img content-ver block');
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var j in $$obj) {
      $$l++;
      var pair = $$obj[j];
var question = pair.question;
var answers = pair.answers;
pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E";
// iterate _.shuffle(pair.answers)
;(function(){
  var $$obj = _.shuffle(pair.answers);
  if ('number' == typeof $$obj.length) {
      for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
        var answer = $$obj[i];
klass  = answer.correct ? "correct" : "incorrect"
klass += i === 0 ? " left" : " right"
pug_html = pug_html + "\u003Cdiv class=\"col-sm-6 block-v-sm slide-up hide-overflow block-box-sizing\"\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["image-container","block-dk","block-sm","content-fill",klass], [false,false,false,false,true]), false, true)+pug_attr("data-correct", answer.correct, true, true)+pug_attr("data-content", answer.content, true, true)+pug_attr("data-answer-id", answer.id, true, true)+pug_attr("data-question-id", question.id, true, true)+pug_attr("data-group", j, true, true)+pug_attr("data-image", i, true, true)) + "\u003E";
pug_mixins["image"](answer.content, 'img content-ver block');
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;
      var answer = $$obj[i];
klass  = answer.correct ? "correct" : "incorrect"
klass += i === 0 ? " left" : " right"
pug_html = pug_html + "\u003Cdiv class=\"col-sm-6 block-v-sm slide-up hide-overflow block-box-sizing\"\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["image-container","block-dk","block-sm","content-fill",klass], [false,false,false,false,true]), false, true)+pug_attr("data-correct", answer.correct, true, true)+pug_attr("data-content", answer.content, true, true)+pug_attr("data-answer-id", answer.id, true, true)+pug_attr("data-question-id", question.id, true, true)+pug_attr("data-group", j, true, true)+pug_attr("data-image", i, true, true)) + "\u003E";
pug_mixins["image"](answer.content, 'img content-ver block');
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["slide-footer","block-v-lg",submitUp ? "slide-footer--up slide-down" : "slide-up"], [false,false,true]), false, true)) + "\u003E";
if (hasPrompt) {
pug_html = pug_html + "\u003Cdiv class=\"slide-footer-touched\"\u003E\u003Cbutton class=\"btn btn-muted btn-done text-ellipsis\" id=\"done-btn\"\u003E" + (null == (pug_interp = doneText || i18n("buttons.continue")) ? "" : pug_interp) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
if (typeof prompt === "string") {
pug_html = pug_html + "\u003Cdiv class=\"slide-footer-prompt text-uppercase text-bold\"\u003E\u003Cdiv class=\"slide-footer-prompt-content content-ver\" id=\"prompt\"\u003E" + (null == (pug_interp = prompt) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
}
else {
pug_html = pug_html + "\u003Cdiv class=\"slide-footer-prompt\"\u003E\u003Cbutton class=\"btn btn-muted btn-done text-ellipsis content-ver\" id=\"prompt-btn\"\u003E" + (null == (pug_interp = continueBtnText || doneText || i18n("buttons.continue")) ? "" : pug_interp) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
}
if (hasNarration) {
pug_html = pug_html + "\u003Cdiv class=\"slide-footer-narration\"\u003E\u003Cdiv class=\"narration-progress btn btn-muted\"\u003E\u003Cdiv class=\"narration-progress-bar\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"wave-ellipse\"\u003E\u003Cspan class=\"bullet delay-1 block-inline\"\u003E&bullet;\u003C\u002Fspan\u003E\u003Cspan class=\"bullet delay-2 block-inline\"\u003E&bullet;\u003C\u002Fspan\u003E\u003Cspan class=\"bullet delay-3 block-inline\"\u003E&bullet;\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }.call(this, "continueBtnText" in locals_for_with ?
        locals_for_with.continueBtnText :
        typeof continueBtnText !== 'undefined' ? continueBtnText : undefined, "doneText" in locals_for_with ?
        locals_for_with.doneText :
        typeof doneText !== 'undefined' ? doneText : undefined, "game" in locals_for_with ?
        locals_for_with.game :
        typeof game !== 'undefined' ? game : undefined, "hasNarration" in locals_for_with ?
        locals_for_with.hasNarration :
        typeof hasNarration !== 'undefined' ? hasNarration : undefined, "hasPrompt" in locals_for_with ?
        locals_for_with.hasPrompt :
        typeof hasPrompt !== 'undefined' ? hasPrompt : undefined, "i18n" in locals_for_with ?
        locals_for_with.i18n :
        typeof i18n !== 'undefined' ? i18n : undefined, "klass" in locals_for_with ?
        locals_for_with.klass :
        typeof klass !== 'undefined' ? klass : undefined, "metadata" in locals_for_with ?
        locals_for_with.metadata :
        typeof metadata !== 'undefined' ? metadata : undefined, "prompt" in locals_for_with ?
        locals_for_with.prompt :
        typeof prompt !== 'undefined' ? prompt : undefined, "submitUp" in locals_for_with ?
        locals_for_with.submitUp :
        typeof submitUp !== 'undefined' ? submitUp : undefined, "title" in locals_for_with ?
        locals_for_with.title :
        typeof title !== 'undefined' ? title : undefined));
    ;;return pug_html;};module.exports=template;